import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import AnimationsSearch from '../components/AnimationsSearch.vue'
import emitter from '../utils/emitter';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        const dates = JSON.parse(this.el.dataset.dates);

        this.app = createApp({
            template: '<AnimationsSearch :dates="dates" />',
            components: {
                AnimationsSearch
            },
            data() {
                return {
                    dates: dates
                }
            },
            mounted() {
            },
        })
        this.app.config.globalProperties.modular = self;
        this.app.config.globalProperties.emitter = emitter;
        this.app.mount(self.el)
    }

    destroy() {
        this.app.unmount();
    }
}